import { Title, Box, Group } from "@mantine/core";
import { PageWithBreadcrumbs } from "../../components/layout/PageWithBreadcrumbs";
import { ContainerWhite } from "../../components/core/ContainerWhite/ContainerWhite";
import { AfaButton, AfaDocumentacionCard, AfaSectionLoader } from "../../components/ui";
import { AfaDocumentacionLink } from "../../components/ui";
// import { AfaModalConfirmation } from "../../components/ui";

import { IconSearch, IconClipboard, IconTable } from "@tabler/icons-react";
import { useState, useEffect } from "react";

const resolveIcon = (iconName: string | null, size = 100) => {
  if (!iconName) return null;

  const icons: any = {
    IconSearch: <IconSearch size={size} stroke={1.5} />,
    IconClipboard: <IconClipboard size={size} stroke={1.5} />,
    IconTable: <IconTable size={size} stroke={1.5} />,
  };

  return icons[iconName] || null;
};

const Documentacion = (props: any) => {
  const [allItems, setAllItems] = useState<any[]>([]);
  const [currentParentId, setCurrentParentId] = useState(0);
  const [stack, setStack] = useState<number[]>([]);
  // const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const data = await props.apiService.GetDocumentation(props.entity.lookupId);
      setAllItems(data);
      setLoading(false);
    };
    load();
  }, []);

  const currentItems = allItems.filter(
    (item) => item.parentId === currentParentId && item.isVisible,
  );
  const currentType = currentItems.length > 0 ? currentItems[0].renderType : "Card";

  const handleClick = (item: any) => {
    if (item.renderType === "Card") {
      setStack((prev) => [...prev, currentParentId]);
      setCurrentParentId(item.id);
    } else if (item.renderType === "Link") {
      handleDownload(item);
      // setOpenConfirm(true);
    }
  };

  const goBack = () => {
    const prev = stack.pop();
    if (prev !== undefined) {
      setStack([...stack]);
      setCurrentParentId(prev);
    }
  };

  const handleDownload = async (item: any) => {
    window.open(item.url, "_blank");
  };

  return (
    <PageWithBreadcrumbs>
      <Title order={1}>Documentació</Title>
      {loading ? (
        <AfaSectionLoader message="Carregant documentació..." />
      ) : (
        <>
          <ContainerWhite>
            <Box bg="brand.0" p="md" style={{ borderRadius: "8px" }}>
              <Group gap="xl" align="flex-start">
                {currentType === "Card" &&
                  currentItems.map((item: any) => (
                    <AfaDocumentacionCard
                      key={item.id}
                      title={item.title}
                      icon={resolveIcon(item.iconName)}
                      onClick={() => handleClick(item)}
                    />
                  ))}

                {currentType === "Link" &&
                  currentItems.map((item: any) => (
                    <AfaDocumentacionLink
                      key={item.id}
                      title={item.title}
                      url={item.url}
                      onClick={() => handleClick(item)}
                    />
                  ))}
              </Group>
            </Box>
            <p></p>
            {stack.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
                <AfaButton
                  id="btn-tornar"
                  variant="outline"
                  onClick={goBack}
                >
                  Tornar
                </AfaButton>
              </div>
            )}
          </ContainerWhite>
        </>
      )}
    </PageWithBreadcrumbs>
  );
};

export default Documentacion;
